import React, { useState, useEffect, useRef } from 'react'; // Import useRef
import { MdArrowDropDown } from "react-icons/md";
import axios from "axios";
import Constant from "../Components/Utils/Constant";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from 'react-router-dom';

export default function CreateCoupon({ onClose }) {
    const [isVisible, setIsVisible] = useState(true);
    const [isDropdownOpenfilter, setIsDropdownOpenfilter] = useState(false);
    const [cuponevent, setCuponevent] = useState("");
    const [cuponcode, setCuponcode] = useState("");
    const [cupondiscount, setCupondiscount] = useState("");
    const [validdays, setValiddays] = useState("");
    const [cuponassign, setCuponassign] = useState([]);
    const [totalCount1, setTotalCount1] = useState(null);
    const [iscuponcodeValid, setIsCuponcodeValid] = useState(true);
    const [isDiscountValid, setIsDiscountValid] = useState(true);
    const [isValiddaysValid, setIsValiddaysValid] = useState(true);
    const navigate = useNavigate();

    // NEW: Create a ref for the dropdown container
    const dropdownRef = useRef(null);

    const dropdownOptions = [
        { id: 1, name: 'Super Admin' },
        { id: 2, name: 'Admin' },
        { id: 3, name: 'Affiliate' },
        { id: 4, name: 'User' },
    ];

    const initialCheckboxStates = {
        1: false,
        2: false,
        3: false,
        4: false,
    };

    const [checkboxStates, setCheckboxStates] = useState(initialCheckboxStates);
    const [selectAllChecked, setSelectAllChecked] = useState(false);

    const handleCheckboxChanged = (id) => {
        setCheckboxStates({
            ...checkboxStates,
            [id]: !checkboxStates[id],
        });
    };

    useEffect(() => {
        const updatedCuponassign = Object.keys(checkboxStates)
            .filter((key) => checkboxStates[key])
            .map((key) => {
                const option = dropdownOptions.find((option) => option.id === parseInt(key));
                return option ? option.name : null;
            })
            .filter((name) => name !== null);
        setCuponassign(updatedCuponassign);
    }, [checkboxStates]);

    const handleSelectAllChanged = () => {
        const newCheckboxStates = {};
        const allChecked = !Object.values(checkboxStates).every((isChecked) => isChecked);

        Object.keys(checkboxStates).forEach((id) => {
            newCheckboxStates[id] = allChecked;
        });

        setCheckboxStates(newCheckboxStates);
        setSelectAllChecked(allChecked);
    };

    const handleClose = () => {
        setIsVisible(false);
        onClose();
    };

    const toggleDropdownfilter = () => {
        setIsDropdownOpenfilter(!isDropdownOpenfilter);
    };

    // NEW: Add useEffect to handle clicks outside the dropdown
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsDropdownOpenfilter(false); // Close the dropdown if click is outside
            }
        };

        // Add event listener when the dropdown is open
        if (isDropdownOpenfilter) {
            document.addEventListener("mousedown", handleClickOutside);
        }

        // Clean up the event listener on component unmount or when dropdown closes
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [isDropdownOpenfilter]); // Re-run the effect when the dropdown state changes


    const validateCuponcode = (cuponcode) => {
        const cuponcodeRegex = /^[a-zA-Z0-9]+$/;
        return cuponcodeRegex.test(cuponcode);
    };
    const validateCupondiscount = (cupondiscount) => {
        const cupondiscountRegex = /^[0-9]+$/;
        return cupondiscountRegex.test(cupondiscount);
    };
    const validateValiddays = (validdays) => {
        const validdaysRegex = /^[0-9]+$/;
        return validdaysRegex.test(validdays);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const isCuponcodeValid = validateCuponcode(cuponcode);
        const isDiscountValid = validateCupondiscount(cupondiscount);
        const isValiddaysValid = validateValiddays(validdays);
        setIsCuponcodeValid(isCuponcodeValid);
        setIsDiscountValid(isDiscountValid);
        setIsValiddaysValid(isValiddaysValid);

        if (isCuponcodeValid && isDiscountValid && isValiddaysValid) {
            try {
                const cuponData = {
                    cuponevent,
                    cuponcode,
                    cupondiscount,
                    validdays,
                    cuponassign,
                };
                const response = await axios.post(
                    `${Constant.BASE_URL}/cupon/upload`,
                    cuponData
                );
                console.log(response.data);

                if (response.status === 201) {
                    setCuponevent("");
                    setCuponcode("");
                    setCupondiscount("");
                    setValiddays("");
                    setCuponassign([]);
                    toast.success("Coupon created successfully");

                    setTimeout(() => {
                        handleClose();
                        navigate("/subscriotionCuppon501");
                    }, 3000);
                } else {
                    console.log("Failed to submit form. Status:", response.status);
                }
            } catch (error) {
                console.log(error);
            }
        }
    };

    return isVisible ? (
        <>
            <ToastContainer position="top-right" autoClose={3000} />
            <div className="popup-form">
                <div className="w-full flex items-center justify-center">
                    <div className="bg-white p-4 rounded-md shadow-md py-3 px-1 lg:py-3 xl:py-3 2xl:p-4">
                        <div className="lg:w-[300px] xl:w-[320px] 2xl:w-[400px] items-center justify-center">
                            <div className="text-lg font-semibold text-center mb-4 2xl:text-4xl">
                                Create Coupon
                            </div>
                            <hr className="mt-1" />
                            <form onSubmit={handleSubmit}>
                                <div className="flex flex-col justify-center items-center">
                                    <div className="lg:py-5 xl:py-5 2xl:py-10 lg:text-[10px] xl:text-[13px] 2xl:text-[22px]">
                                        <div className="flex py-3 justify-end items-center">
                                            <label htmlFor="yourInput" className="flex items-end px-3">
                                                Coupon Event :
                                                <span className="text-red-500 ml-1">*</span>
                                            </label>
                                            <input
                                                type="text"
                                                id="yourInput"
                                                className="border-b border-gray-500 outline-none flex items-start mb-2"
                                                style={{ width: "163px", textAlign: "center" }}
                                                placeholder="Text"
                                                value={cuponevent}
                                                onChange={(e) => setCuponevent(e.target.value)}
                                                required
                                            />
                                        </div>
                                        <div className="flex py-3 justify-end items-center">
                                            <label htmlFor="couponCode" className="flex items-end px-3">
                                                Coupon Code :
                                                <span className="text-red-500 ml-1">*</span>
                                            </label>
                                            <div className="flex flex-col">
                                                <input
                                                    type="text"
                                                    id="couponCode"
                                                    name="couponCode"
                                                    className="border-b border-gray-500 outline-none flex items-start mb-2"
                                                    style={{ width: "163px", textAlign: "center" }}
                                                    placeholder="Alpha Numeric"
                                                    value={cuponcode}
                                                    onChange={(e) => setCuponcode(e.target.value)}
                                                    required
                                                />
                                                {!iscuponcodeValid && (
                                                    <p className="text-red-500 text-xs mt-1 w-[163px] text-center">
                                                        Should be alpha-numeric.
                                                    </p>
                                                )}
                                            </div>
                                        </div>
                                        <div className="flex py-3 justify-end items-center">
                                            <label htmlFor="couponDiscount" className="flex items-end px-3">
                                                Coupon Discount :
                                                <span className="text-red-500 ml-1">*</span>
                                            </label>
                                            <div className="flex flex-col">
                                                <input
                                                    type="text"
                                                    id="couponDiscount"
                                                    name="couponDiscount"
                                                    className="border-b border-gray-500 outline-none flex items-start mb-2"
                                                    style={{ width: "163px", textAlign: "center" }}
                                                    placeholder="Number %"
                                                    value={cupondiscount}
                                                    onChange={(e) => setCupondiscount(e.target.value)}
                                                    required
                                                />
                                                {!isDiscountValid && (
                                                    <p className="text-red-500 text-xs mt-1 w-[163px] text-center">
                                                        Should be a number.
                                                    </p>
                                                )}
                                            </div>
                                        </div>
                                        <div className="flex py-3 justify-end items-center">
                                            <label htmlFor="validDays" className="flex items-end px-3">
                                                Valid Days :<span className="text-red-500 ml-1">*</span>
                                            </label>
                                             <div className="flex flex-col">
                                                <input
                                                    type="text"
                                                    id="validDays"
                                                    className="border-b border-gray-500 outline-none flex items-start mb-2"
                                                    style={{ width: "163px", textAlign: "center" }}
                                                    placeholder="Text (10 Days)"
                                                    value={validdays}
                                                    onChange={(e) => setValiddays(e.target.value)}
                                                    required
                                                />
                                                {!isValiddaysValid && (
                                                    <p className="text-red-500 text-xs mt-1 w-[163px] text-center">
                                                        Should be a number.
                                                    </p>
                                                )}
                                            </div>
                                        </div>

                                        <div className="flex justify-end">
                                            {/* NEW: Attach the ref to the dropdown's parent div */}
                                            <div ref={dropdownRef} className="relative flex items-center justify-start py-3 cursor-pointer">
                                                <label htmlFor="couponAssign" className="flex items-end px-3 ">
                                                    Coupon Assign :<span className="ml-1 text-red-500">*</span>
                                                </label>
                                                <div className="flex pb-1 border-b border-gray-500 outline-none ">
                                                    <input
                                                        type="text"
                                                        id="couponAssign"
                                                        placeholder="Select category"
                                                        value={cuponassign.join(', ')}
                                                        readOnly
                                                        style={{ border: "none", outline: "none" }}
                                                        required
                                                    />
                                                    <MdArrowDropDown
                                                        onClick={toggleDropdownfilter}
                                                        className="text-xl"
                                                    />
                                                    {isDropdownOpenfilter && (
                                                        <div
                                                            style={{
                                                                border: "1px solid #0000000a",
                                                                zIndex: "100",
                                                            }}
                                                            className="lg:text-[10px] xl:w-[163px] lg:w-fit xl:text-[15px] py-1 absolute top-9 left-25 bg-white shadow-xl rounded-md "
                                                        >
                                                            <ul className='overflow-y-auto h-[130px] modelscroll'>
                                                                <li className="border-t px-2 py-1 cursor-pointer text-black flex justify-between items-center">
                                                                    <span className='text-[12px]'>All</span>
                                                                    <div className='flex justify-end items-center'>
                                                                        <label className="inline-flex items-center">
                                                                            <div className={`w-4 h-4 bg-white border border-black-300 shadow-lg rounded-sm flex items-center justify-center ml-2 ${selectAllChecked ? 'bg-red-500' : ''}`}>
                                                                                {selectAllChecked && (
                                                                                    <div className="w-2 h-2 bg-gradient-to-r from-yellow-200 to-orange-500"></div>
                                                                                )}
                                                                            </div>
                                                                            <input
                                                                                className="hidden"
                                                                                type="checkbox"
                                                                                checked={selectAllChecked}
                                                                                onChange={handleSelectAllChanged}
                                                                            />
                                                                        </label>
                                                                    </div>
                                                                </li>
                                                                {dropdownOptions.map((option) => (
                                                                    <li key={option.id} className="border-t px-2 py-1 cursor-pointer text-black flex justify-between items-center">
                                                                        <span className="text-[12px]">{option.name}</span>
                                                                        <div className="flex items-center">
                                                                            <label className="inline-flex items-center">
                                                                                <div className={`w-4 h-4 bg-white border border-black-300 shadow-lg rounded-sm flex items-center justify-center ml-2 ${checkboxStates[option.id] ? 'bg-red-500' : ''}`}>
                                                                                    {checkboxStates[option.id] && <div className="w-2 h-2 bg-gradient-to-r from-yellow-200 to-orange-500"></div>}
                                                                                </div>
                                                                                <input
                                                                                    className="hidden"
                                                                                    type="checkbox"
                                                                                    checked={checkboxStates[option.id]}
                                                                                    onChange={() => handleCheckboxChanged(option.id)}
                                                                                />
                                                                            </label>
                                                                        </div>
                                                                    </li>
                                                                ))}
                                                            </ul>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="button-container flex justify-center p-1 space-x-12 lg:pb-5 xl:pb-5 2xl:pb-5 lg:text-[10px] xl:text-[13px] 2xl:text-[22px]">
                                        <button
                                            type="button"
                                            onClick={handleClose}
                                            className="bg-white px-3 py-1 flex-shrink-0 shadow-md rounded-sm"
                                            style={{
                                                boxShadow: "0px 4px 8px 0px rgba(0, 0, 0, 0.25)",
                                            }}
                                        >
                                            Cancel
                                        </button>
                                        <button
                                            type="submit"
                                            className="px-3 py-1 flex-shrink-0 rounded-sm"
                                            style={{
                                                background:
                                                    "radial-gradient(125% 125% at 85.42% 0%, #FFD6A6 0%, #FF9C28 100%)",
                                            }}
                                        >
                                            Save
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    ) : null;
}
